<template>
  <v-app style="background: #f7f8f9">
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
.v-application {
  font-family: MontForAnker, "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
</style>
